import React from 'react';
import { Link } from 'react-router-dom';
import { animated, useTransition } from '@react-spring/web';

import { marked } from 'marked';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAnimatedRouteState } from '@wildidea/components/AnimatedRoutes/AnimatedRoutes';
import { Card } from '@wildidea/components/Card/Card';
import { useThemeAnimations } from '@wildidea/components/Theme/Theme';

import { SCRIBE_USAGE_AGREEMENT } from './scribe-agreement.js';

import * as css from './ScribeAgreementRoute.module.css';

import 'github-markdown-css';

const html = marked(SCRIBE_USAGE_AGREEMENT);

const ScribeAgreementRoute: React.FC<{}> = () => {
  const { phase, onTransitionEnd } = useAnimatedRouteState();
  const active = phase === 'enter' || phase === 'active';
  const { fromBelow } = useThemeAnimations('Common');
  const contentTransition = useTransition(active, { ...fromBelow, onRest: onTransitionEnd });
  return contentTransition((style, active) =>
    active ? (
      <animated.div style={style} className={css.layout}>
        <Card
          color="transparent"
          className={css.contentCard}
          header={
            <div className={[css.header, 'h1-margin'].join(' ')}>
              <Link to="/" aria-label="Back">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Link>
              <h1>Scribe Usage Agreement</h1>
            </div>
          }
        >
          <article dangerouslySetInnerHTML={{ __html: html.toString() }} />
        </Card>
      </animated.div>
    ) : null
  );
};

export default ScribeAgreementRoute;
